import React from 'react';

import { stringOfLength } from '../../utils/validateString';
import { ContentText, Label, LabelContainer } from './Radio.styles';
import { RadioProps } from './Radio.types';

export const Radio: React.FC<RadioProps> = ({
  style,
  label,
  checked,
  onChange,
  disabled,
  bordered,
  content,
  side = 'right',
  width,
  justifyContent,
  ...props
}) => {
  content && stringOfLength(content, 0, 60);
  const handleChange = event => {
    console.log('handleChange');
    onChange && onChange(event);
  };
  return (
    <Label
      disabled={disabled}
      onChange={handleChange}
      bordered={bordered}
      checked={checked}
      style={style}
      side={side}
      role="tmov-input-radio"
      hasContent={!!content}
      width={width}
      justifyContent={justifyContent ?? side === 'right' ? 'flex-start' : 'space-between'}
    >
      <input
        type="radio"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        {...props}
      />
      <LabelContainer>
        {label}
        {content && <ContentText disabled={disabled}>{content}</ContentText>}
      </LabelContainer>
    </Label>
  );
};
